<template>
  <div>
    <cx-slider
      :style="sliderStyle"
      :options="sliders"
      :label="showTitle ? title : ''"
      :value.sync="currentSliderStatus"
    ></cx-slider>
    <div v-for="(item, index) in currentSettings" :key="currentSettings.title">
      <basic-setting
        :style="{padding: '12px 16px'}"
        v-if="typeof item === 'string' || item.type === 'basic'"
        :config="item"
      />
      <sub-collapse-setting v-else-if="item.type === 'subCollapse'" :settings="item.settings" :title="item.title" :tips="item.tips" />
      <block-setting v-else-if="item.type === 'block'" :settings="item.settings" />
      <collapse-setting v-else-if="item.type === 'collapse'" :settings="item.settings" :title="item.title" :initStatus="item.initStatus" :key="item.title"/>
      <collection-setting v-else-if="item.type === 'collection'  && enable(item)" :settings="item.settings" :title="item.title"/>
    </div>
  </div>
</template>
<script>
import blockSetting from "./block-setting.vue"; 
import basicSetting from "./basic-setting.vue"
import subCollapseSetting from "./sub-collapse-setting.vue";
import collectionSetting from "./collection-setting.vue";
export default {
  components: {
    basicSetting,
    blockSetting,
    subCollapseSetting,
    collapseSetting: () => import('./collapse-setting.vue'),
    collectionSetting
  },
  inject: ['configData', 'configs', 'mergedConfigData'],
  props: {
    isRoot: {
      type: Boolean,
      default: false
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '状态'
    },
    statusSettings: Array
  },
  data() {
    return {
      currentStatus: this.statusSettings[0]?.title
    }
  },  
  computed: {
    sliderStyle() {
      return this.isRoot ? {padding: '12px 16px'} : {}
    },
    sliders() {
      return this.statusSettings.map(item => ({
        title: item.title,
        value: item.title
      }))
    },
    enable() {
      return function (config) {
        if (config.enable) {
          return config.enable(this.mergedBasicConfigData)
        }
        return true
      }
    },
    currentSliderStatus: {
      get() {
        return this.currentStatus
      },
      set(value) {
        this.currentStatus = value
      }
    },
    currentSettings() {
      return this.statusSettings.find(item => item.title === this.currentStatus)?.settings
    },
    basicConfigData() {
      return this.configData()
    },
    mergedBasicConfigData() {
      return this.mergedConfigData()
    }
  }
}
</script>
